import { render, staticRenderFns } from "./ResSvg.vue?vue&type=template&id=b8d9a2ec"
import script from "./ResSvg.vue?vue&type=script&lang=js"
export * from "./ResSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports